module.exports = __webpack_public_path__ + "static/media/lidcore-detection-1.d73704b4.jpg";